import { TheWestSection } from '@news-mono/common'
import { getFederalElectionData, metrics } from '@news-mono/component-library'
import {
    Election,
    getElectionId,
    GetRouteAdTargeting,
    PageType,
} from '@news-mono/web-common'
import { layout } from '../../../App.routing'

const DESKTOP_LOGO: string = require('../assets/WAStateElection2025LogoDesktop.svg')
const MOBILE_LOGO: string = require('../assets/WAStateElection2025LogoMobile.svg')

type CreateElectionPageArgs = {
    election: Election
    getAdTargeting: GetRouteAdTargeting
}

export const createElectionWidgetTestPage = ({
    election,
    getAdTargeting,
}: CreateElectionPageArgs): PageType<TheWestSection> => {
    return {
        kind: 'page',
        heading: 'Election Widget Test Page',
        pageType: 'static',
        section: 'default',
        hideHeading: true,
        adTargeting: getAdTargeting('home', 'default', 'home'),
        pageMeta: {
            description: 'Election Widget Test Page',
        },
        socialMeta: {
            description: 'Election Widget Test Page',
        },
        compositions: [
            layout.composition({
                type: 'box',
                props: {
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    fullWidth: true,
                },
                contentAreas: {
                    main: [
                        layout.component({
                            type: 'election-navigation',
                            props: {
                                election: {
                                    type: 'state',
                                    state: 'wa',
                                    year: 2025,
                                    logo: {
                                        mobile: MOBILE_LOGO,
                                        desktop: DESKTOP_LOGO,
                                    },
                                },
                            },
                        }),
                        layout.component({
                            type: 'election-the-race-widget',
                            props: {
                                electionData: getFederalElectionData(),
                            },
                        }),
                        layout.component({
                            type: 'election-seat-widget',
                            props: {
                                dataDefinitionArgs: {
                                    type: 'election',
                                    electionId: 632,
                                    pageSize: 1, // Throwaway value, required to pass type check ¯\_(ツ)_/¯
                                },
                                electoratePageUrl: `/politics/${getElectionId(
                                    election,
                                )}/electorates`,
                            },
                        }),
                        layout.component({
                            type: 'election-seat-embed-collection-widget',
                            props: {},
                        }),
                    ],
                },
            }),
        ],
    }
}
